import type { AppRoutesState } from '@modules/store/common/types/AppRoutesState.entity';

export const state: AppRoutesState = {
  initialRoutes: [],
  numberOfVisibleRoutesAllowed: undefined,
  currentRouteIndex: 0,
  hideProgressBar: false,
  exit: {
    exitButtonEnabled: false,
    exitRouteName: '',
  },
};
